import React, { useState, useEffect, useRef, useMemo } from 'react';
// import { LandingPageHeroTextLoop } from '../Components/LandingPageHeroTextLoop';
import { LandingNavigation } from '../Components/landing-navigation';
import '../Styling/landingPage.css';
import { useIsMobile } from '../../custom-hooks/useIsMobile';
import { Flame, Cog, Store, Rocket, MonitorPlay, Twitter, Instagram, Linkedin, ChevronRight, Plus, Send, Check } from 'lucide-react';
import { StyleLinks } from '../../orgViews/OrgCommonComponents';
import { handleHashScroll } from '../../utils/scrollToSection';
// Previous Operations animation retained for rollback.
// import {WorkyOpsDemo} from "../Components/WorkyOpsDemo/WorkyOpsDemo";
import { WorkyCareOperationsDemo } from "../Components/WorkyCareOperationsDemo/WorkyCareOperationsDemo";
import {WorkySalesDemo} from "../Components/WorkySalesDemo/WorkySalesDemo";
import {WorkyMarketplaceDemo} from "../Components/WorkyMarketplaceDemo/WorkyMarketplaceDemo";
import { Rating, Tooltip } from '@mui/material';
import { SiG2, SiTrustpilot } from "react-icons/si";
import { FaUsers } from "react-icons/fa";
import {WorkyOpsDemoTwo} from "../Components/WorkyOpsDemo/WorkyOpsDemoTwo";
import {WorkyMainDemo} from "../Components/WorkyMainDemo/WorkyMainDemo";
import {WorkyMainDemoMobile} from "../Components/WorkyMainDemo/WorkyMainDemoMobile";
import TextLoop from '../Components/LandingPageHeroTextLoop';
import { LPTestimonials } from './LandingPageSubComponents';
import { WorkyPricingTeaser } from '../Components/WorkyPricingTeaser/WorkyPricingTeaser';

import { HealthcareBentoGrid } from '../Components/BentoGrids/HealthcareBentoGrid/HealthcareBentoGrid';
import { RecruitingBentoGrid } from '../Components/BentoGrids/RecruitingBentoGrid/RecruitingBentoGrid';
import { SecurityBentoGrid } from '../Components/BentoGrids/SecurityBentoGrid/SecurityBentoGrid';
import { StaffingBentoGrid } from '../Components/BentoGrids/StaffingBentoGrid/StaffingBentoGrid';
import { OtherBentoGrid } from '../Components/BentoGrids/OtherBentoGrid/OtherBentoGrid';
import { SalesTrackerHotIntakeReqDTO } from '../../splashComponent/sales-related/sales-related-data/SalesTrackerHotIntakeInterfaces';
import { SalesTrackerHotIntakeAPICall } from '../../splashComponent/sales-related/sales-related-api/SalesTrackerAPICalls';
import { IncrementPitchPopUpCount, LOCAL_STORAGE_KEYS, RetrieveFromLocalCache, isValidString } from '../../common/CommonUtilsMethods';
import { useSnackbar } from 'notistack';
import { ListenForPageCloseAndExecute, MakeRemoteTrackingEventCall } from '../../splashComponent/sales-related/sales-related-services/SalesTrackerServices.tsx';
import { openWorkyCalendlyDemoInNewTab } from '../../analytics/openWorkyCalendlyDemo';
import { pushWorkyMarketingAnalyticsEvent } from '../../analytics/pushWorkyMarketingAnalyticsEvent';
import { TAG_DICTIONARY } from '../../analytics/TagDictionary';
import { homeSeo } from '../seo/LandingPageSeoConfig';
import { useLandingPageSeo } from '../seo/useLandingPageSeo';
import { WORKY_WEB_APP_PATHS } from '../../WorkyWebAppPaths';
import { TurnstileWidget } from '../Components/TurnstileWidget';
import {
    HOT_INTAKE_ACTIVE_EMPLOYEES_OPTIONS,
    HOT_INTAKE_NEW_AGENCY_INCENTIVE_COPY,
    HotIntakeSelectOption,
    HOT_INTAKE_BLOCKED_EMAIL_SNACKBAR,
    isBlockedHotIntakeEmailDomain,
    isValidHotIntakeEmail,
    isValidHotIntakePhone,
    isValidOptionalHotIntakePreferredCallSlot,
    navigateToContactSalesPage,
    normalizeHotIntakePreferredCallTime,
} from '../Components/HotIntakeLeadFormShared';


type LPChipDirection = 'left' | 'right';

interface LPChipProps {
    readonly text: string;
    readonly direction?: LPChipDirection;
}

const LPChip = ({ text, direction }: LPChipProps): React.JSX.Element => {
    const alignmentStyle: React.CSSProperties = direction === 'left'
        ? { marginTop: 0, marginBottom: 0, marginLeft: 0, marginRight: 'auto' }
        : direction === 'right'
            ? { marginTop: 0, marginBottom: 0, marginLeft: 'auto', marginRight: 0 }
            : {};

    return (
        <div className='lp-chip' style={alignmentStyle}>
            {text.toUpperCase()}
        </div>
    )
}

const LPChipAlt = ({ text }: { text: string }) => {

    return (
        <div className='lp-chip-alt'>
            {text.toUpperCase()}
        </div>
    )
}

interface AnimatedSubtitleSpanProps {
    readonly children: React.ReactNode;
    readonly Icon: React.ComponentType<{
        readonly className?: string;
        readonly size?: string | number;
        readonly color?: string;
    }>;
    readonly defaultClassName: string;
    readonly animateClassName: string;
    readonly hoverClassName: string;
    readonly visibleClassName: string;
    readonly iconClassName: string;
    readonly iconPersistClassName: string;
    readonly iconSettledClassName: string;
    readonly iconColor: string;
}

const AnimatedSubtitleSpan = ({
    children,
    Icon,
    defaultClassName,
    animateClassName,
    hoverClassName,
    visibleClassName,
    iconClassName,
    iconPersistClassName,
    iconSettledClassName,
    iconColor,
}: AnimatedSubtitleSpanProps): React.JSX.Element => {
    const [showIcon, setShowIcon] = useState<boolean>(false);
    const [hasAnimated, setHasAnimated] = useState<boolean>(false);
    const [isHovered, setIsHovered] = useState<boolean>(false);
    const [iconKey, setIconKey] = useState<number>(0);

    useEffect((): (() => void) | void => {
        if (!hasAnimated) {
            setShowIcon(true);
            const timer: ReturnType<typeof setTimeout> = setTimeout((): void => {
                setShowIcon(false);
                setHasAnimated(true);
            }, 1500);
            return (): void => clearTimeout(timer);
        }
    }, [hasAnimated]);

    const handleMouseEnter = (): void => {
        setIsHovered(true);
        setIconKey((prev: number): number => prev + 1);
        setShowIcon(true);
    };

    const handleMouseLeave = (): void => {
        setIsHovered(false);
        setShowIcon(false);
    };

    const shouldShowIcon: boolean = showIcon || hasAnimated;
    const resolvedIconClassName: string = isHovered
        ? `${iconClassName} ${iconPersistClassName}`
        : hasAnimated
            ? `${iconClassName} ${iconSettledClassName}`
            : iconClassName;

    return (
        <span
            className={`lph-subtitle-span ${hasAnimated ? defaultClassName : animateClassName} ${isHovered ? hoverClassName : ''} ${shouldShowIcon ? visibleClassName : ''}`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            {shouldShowIcon ? (
                <Icon
                    key={iconKey}
                    className={resolvedIconClassName}
                    size={18}
                    color={iconColor}
                />
            ) : null}
            {children}
        </span>
    );
}

const AnimatedFlameSpan = ({ children }: { children: React.ReactNode }): React.JSX.Element => {
    return (
        <AnimatedSubtitleSpan
            Icon={Flame}
            defaultClassName='flame-text-default'
            animateClassName='flame-text-animate'
            hoverClassName='flame-text-hover'
            visibleClassName='flame-icon-visible'
            iconClassName='flame-icon'
            iconPersistClassName='flame-icon-persist'
            iconSettledClassName='flame-icon-settled'
            iconColor='#ff6b35'
        >
            {children}
        </AnimatedSubtitleSpan>
    );
}

const AnimatedCogSpan = ({ children }: { children: React.ReactNode }): React.JSX.Element => {
    return (
        <AnimatedSubtitleSpan
            Icon={Cog}
            defaultClassName='cog-text-default'
            animateClassName='cog-text-animate'
            hoverClassName='cog-text-hover'
            visibleClassName='cog-icon-visible'
            iconClassName='cog-icon'
            iconPersistClassName='cog-icon-persist'
            iconSettledClassName='cog-icon-settled'
            iconColor='#2c68bd'
        >
            {children}
        </AnimatedSubtitleSpan>
    );
}

const AnimatedStoreSpan = ({ children }: { children: React.ReactNode }): React.JSX.Element => {
    return (
        <AnimatedSubtitleSpan
            Icon={Store}
            defaultClassName='store-text-default'
            animateClassName='store-text-animate'
            hoverClassName='store-text-hover'
            visibleClassName='store-icon-visible'
            iconClassName='store-icon'
            iconPersistClassName='store-icon-persist'
            iconSettledClassName='store-icon-settled'
            iconColor='#22c55e'
        >
            {children}
        </AnimatedSubtitleSpan>
    );
}








const LPHero = ({ isMobile }: { isMobile: boolean }) => {

    const HeroSectionText = () => {
        const demoRef = useRef<HTMLDivElement>(null);
        const [demoRotation, setDemoRotation] = useState<number>(32);
        const [isHoveringDemo, setIsHoveringDemo] = useState<boolean>(false);
        const [tiltX, setTiltX] = useState<number>(0);
        const [tiltY, setTiltY] = useState<number>(0);

        useEffect((): (() => void) => {
            const handleScroll = (): void => {
                if (!demoRef.current) return;
                const rect: DOMRect = demoRef.current.getBoundingClientRect();
                const windowHeight: number = window.innerHeight;
                const scrollProgress: number = Math.max(0, Math.min(1,
                    (windowHeight - rect.top) / (windowHeight * 0.75)
                ));
                setDemoRotation(32 * (1 - scrollProgress));
            };
            window.addEventListener('scroll', handleScroll, { passive: true });
            handleScroll();
            return (): void => window.removeEventListener('scroll', handleScroll);
        }, []);

        const handleDemoMouseMove = (e: React.MouseEvent<HTMLDivElement>): void => {
            if (!demoRef.current) return;
            const rect: DOMRect = demoRef.current.getBoundingClientRect();
            const normalizedX: number = ((e.clientX - rect.left) / rect.width) * 2 - 1;
            const normalizedY: number = ((e.clientY - rect.top) / rect.height) * 2 - 1;
            const maxTilt: number = 1;
            setTiltX(-normalizedY * maxTilt);
            setTiltY(normalizedX * maxTilt);
        };

        const handleDemoMouseEnter = (): void => setIsHoveringDemo(true);

        const handleDemoMouseLeave = (): void => {
            setIsHoveringDemo(false);
            setTiltX(0);
            setTiltY(0);
        };

        return (
            <div className='hero-section-container'>

                <div className={isMobile?'hero-section-text-mobile':'hero-section-text'}>
                    <h1 className={isMobile? 'hero-section-loop-text-mobile' : 'hero-section-loop-text'}>

                        <span> Helping </span> 
                        {isMobile?<br/>:null} 
                        {/* <LandingPageHeroTextLoop
                            intervalMs={3000}
                            mask={true}
                            springConfig={{ stiffness: 70, damping: 11 }}
                        > */}
                        <TextLoop interval={1500}>
                            {/* Temporarily paused on Healthcare only — restore other loop items when ready */}
                            <div className='text-loop-container' style={isMobile?{flexDirection:'column', gap:'0px'}:{}}>
                                <div className='text-loop-image'><div className='text-loop-image-inner'><img src="./healthcare-lp.jpeg" alt="Healthcare staffing software for agencies"/></div></div>
                                <div className='text-loop-text'>Homecare</div>
                            </div>
                            {/*
                            <div className='text-loop-container' style={isMobile?{flexDirection:'column', gap:'0px'}:{}}>
                                <div className='text-loop-text'>Staffing</div>
                                <div className='text-loop-image'><div className='text-loop-image-inner'><img src="./staffing-lp.jpeg"/></div></div>
                            </div>

                            <div className='text-loop-container' style={isMobile?{flexDirection:'column', gap:'0px'}:{}}>
                                <div className='text-loop-text'>Recruiting</div>
                                <div className='text-loop-image'><div className='text-loop-image-inner'><img src="./recruiting-lp.jpeg"/></div></div>
                            </div>
                            
                            <div className='text-loop-container' style={isMobile?{flexDirection:'column', gap:'0px'}:{}}>
                                <div className='text-loop-image'><div className='text-loop-image-inner'><img src="./security-lp3.jpeg"/></div></div>
                                <div className='text-loop-text'>Security</div>
                            </div>
                            */}
                        </TextLoop>

                        {isMobile?<br/>:null} 
                        <span> Agencies </span>
                        {isMobile ? <br /> : <span>&nbsp;</span>}
                        <span> Grow! </span>

                    </h1>
                    
                    <h2 className={isMobile?'lph-subtitle-mobile':'lph-subtitle'}>

                        Contact {isMobile?null:null} 

                        <AnimatedFlameSpan>Hot & Qualified leads</AnimatedFlameSpan> 

                        ,
                        
                        <AnimatedCogSpan>Manage Operations Effeciently</AnimatedCogSpan>
                        
                        , and access the {' '}
                        
                        <AnimatedStoreSpan>Worky Marketplace</AnimatedStoreSpan>
                        
                        {isMobile?' ':<br/>} 
                        
                        with the all-in-one{' '}
                        <span>healthcare staffing software</span>
                        {' '}for{' '}
                        <span>Modern Agencies</span>!
                    
                    </h2>
                    
                    <div className='lph-button-holder'>
                        <button className='lph-button' onClick={(): void => { openWorkyCalendlyDemoInNewTab('lp_hero_book_demo'); }}>Book Demo <MonitorPlay size={15} /></button>
                        <button onClick={navigateToContactSalesPage} className='lph-button lp-cta-button'>Get Started <Rocket size={15} /></button>
                    </div>

                    <div className={isMobile?'lph-review-holder-mobile':'lph-review-holder'}>
                        <Tooltip title="Rated 4.9/5 on G2 — loved by staffing & recruiting teams worldwide">
                            <div className='lph-review-item'>
                                <div className='lph-review-item-icon'><SiG2 size={20} color='#FF492C' /></div>
                                <div className='lph-review-item-rating'><Rating value={5} readOnly sx={{fontSize:17}}/></div>
                                <div className='lph-review-item-text'>4.9 Rating</div>
                            </div>
                        </Tooltip>
                        <Tooltip title="Join 150,000+ agency professionals already growing with Worky">
                            <div className='lph-review-item'>
                                <div className='lph-review-item-icon'><FaUsers size={20} color="#5a9bd6" /></div>
                                {/* <div className='lph-review-item-rating'></div> */}
                                <div className='lph-review-item-text'>+250k Users</div>
                            </div>
                        </Tooltip>
                        <Tooltip title="Rated Excellent on Trustpilot — agencies trust Worky to run their business">
                            <div className='lph-review-item'>
                                <div className='lph-review-item-icon'><SiTrustpilot size={20} color="#00B77F" /></div>
                                <div className='lph-review-item-rating'><Rating value={5} readOnly sx={{fontSize:17}}/></div>
                                <div className='lph-review-item-text'>4.9 Rating</div>
                            </div>
                        </Tooltip>
                    </div>
                    
                </div>
            
                <div
                    ref={demoRef}
                    className={isMobile ? 'hero-section-demo-mobile' : 'hero-section-demo'}
                    style={{
                        transform: isHoveringDemo
                            ? `perspective(900px) rotateX(${tiltX}deg) rotateY(${tiltY}deg)`
                            : `perspective(900px) rotateX(${demoRotation}deg)`,
                        transition: isHoveringDemo
                            ? 'transform 0.06s ease-out'
                            : 'transform 0.45s ease-out',
                    }}
                    onMouseMove={handleDemoMouseMove}
                    onMouseEnter={handleDemoMouseEnter}
                    onMouseLeave={handleDemoMouseLeave}
                >
                    {isMobile ? <WorkyMainDemoMobile /> : <WorkyMainDemo />}
                </div>

                <LPTrust isMobile={isMobile}/>
                
                <LPProduct isMobile={isMobile}/>

                <LPIndustries isMobile={isMobile}/>

                <WorkyPricingTeaser isMobile={isMobile} onPricingClick={(): void => {
                    pushWorkyMarketingAnalyticsEvent({
                        event: TAG_DICTIONARY.EVENTS.CTA_CLICK,
                        cta_id: 'lp_pricing_talk_sales',
                        cta_label: 'Let’s talk pricing',
                    });
                    navigateToContactSalesPage();
                }} />

                <LPTestimonials isMobile={isMobile} Chip={LPChip} />

                {/* <LPPricing isMobile={isMobile}/> */}

                <LPFooter isMobile={isMobile}/>
            </div>
        )
    }




    return (
        <div className='lp-hero-section'>
            <WavyBackground/>
            <HeroSectionText/>
        </div>
    )
}

interface WavyBackgroundProps {
    readonly colors?: readonly string[];
    readonly speed?: number;
    readonly amplitude?: number;
    readonly bandThickness?: number;
    readonly spacing?: number;
    readonly angle?: number;
}

const WavyBackground = ({
    colors = [
        // "#1e3a8a", // blue-900
        // "#1d4ed8", // blue-700
        "#3b82f6", // blue-500
        "#60a5fa", // blue-400
        "#93c5fd", // blue-300
        "#bfdbfe", // blue-200
        "#e0f2fe", // blue-100
    ],
    speed = 0.00095,
    amplitude = 60,
    bandThickness = 80,
    spacing = 25,
    angle = -Math.PI / 2.8, // Approx diagonal angle
}: WavyBackgroundProps): React.JSX.Element => {
    const containerRef = useRef<HTMLDivElement | null>(null);
    const canvasRef = useRef<HTMLCanvasElement | null>(null);
    const timeRef = useRef<number>(0);
    const [isInViewport, setIsInViewport] = useState<boolean>(false);

    useEffect((): (() => void) | void => {
        const containerElement: HTMLDivElement | null = containerRef.current;
        if (!containerElement) return undefined;

        const observer: IntersectionObserver = new IntersectionObserver(
            (entries: readonly IntersectionObserverEntry[]): void => {
                const firstEntry: IntersectionObserverEntry | undefined = entries[0];
                setIsInViewport(Boolean(firstEntry?.isIntersecting));
            },
            {
                threshold: 0.1,
            }
        );

        observer.observe(containerElement);

        return (): void => {
            observer.disconnect();
        };
    }, []);

    useEffect((): (() => void) | void => {
        const canvas: HTMLCanvasElement | null = canvasRef.current;
        if (!canvas || !isInViewport) return undefined;

        const ctx: CanvasRenderingContext2D | null = canvas.getContext("2d");
        if (!ctx) return undefined;

        let animationFrameId: number | null = null;
        let time: number = timeRef.current;

        const render = (): void => {
            // Handle high-DPI displays (Retina screens)
            const dpr: number = window.devicePixelRatio || 1;
            const width: number = window.innerWidth;
            const height: number = window.innerHeight * 2.5;

            // Only resize if dimensions change to avoid canvas clearing flicker
            if (canvas.width !== width * dpr || canvas.height !== height * dpr) {
                canvas.width = width * dpr;
                canvas.height = height * dpr;
                canvas.style.width = `${width}px`;
                canvas.style.height = `${height}px`;
                ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
            }

            ctx.clearRect(0, 0, width, height);

            // Move to center to rotate properly
            ctx.save();
            ctx.translate(width / 2, height / 2);
            ctx.rotate(angle);

            // Calculate how long the bands need to be to cover the screen diagonally
            const length: number = Math.max(width, height) * 2.5;
            const startX: number = -length / 2;
            const endX: number = length / 2;

            colors.forEach((color: string, index: number): void => {
                ctx.beginPath();

                // Offset each band so they sit next to each other
                const baseY: number = (index - colors.length / 2) * spacing;

                // Draw the wavy line
                for (let x: number = startX; x <= endX; x += 20) {
                    // Sine wave function for organic movement.
                    // Phase offset uses the index so they don't move identically.
                    const y: number = baseY + Math.sin(x * 0.003 + time + index * 0.5) * amplitude;

                    if (x === startX) {
                        ctx.moveTo(x, y);
                    } else {
                        ctx.lineTo(x, y);
                    }
                }

                ctx.lineWidth = bandThickness;
                ctx.strokeStyle = color;
                ctx.lineCap = "round";
                ctx.lineJoin = "round";
                ctx.stroke();
            });

            ctx.restore();

            time += speed;
            timeRef.current = time;
            animationFrameId = window.requestAnimationFrame(render);
        };

        render();

        return (): void => {
            if (animationFrameId !== null) {
                window.cancelAnimationFrame(animationFrameId);
            }
        };
    }, [angle, amplitude, bandThickness, colors, isInViewport, spacing, speed]);

    return (
        <div
            ref={containerRef}
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '250vh',
                overflow: 'hidden',
                pointerEvents: 'none',
                zIndex: 0,
            }}
        >
            <canvas
                ref={canvasRef}
                style={{
                    width: '100%',
                    height: '100%',
                    maskImage: "radial-gradient(circle at center, black 30%, transparent 80%)",
                    WebkitMaskImage: "radial-gradient(circle at center, black 30%, transparent 80%)",
                }}
            />
        </div>
    );
};


const LPTrust = ({ isMobile }: { isMobile: boolean }) => {
    const scrollContainerRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const [isPaused, setIsPaused] = useState(false);
    const animationRef = useRef(null);
    // Add this with your other useRefs
    const scrollPos = useRef(0);

    // ADJUST THIS VALUE: 0.5 is half speed, 0.2 is very slow, 1 is normal
    const speed = 0.4; 

    const logos: readonly { readonly id: number; readonly name: string; readonly src: string }[] = [
        { id: 0, name: 'Logo 1', src: '/lp-logo1.png' },
        { id: 1, name: 'Logo 2', src: '/lp-logo2.png' },
        { id: 2, name: 'Logo 3', src: '/lp-logo3.svg' },
        { id: 3, name: 'Logo 4', src: '/lp-logo4.png' },
        { id: 4, name: 'Logo 5', src: '/lp-logo5.png' },
        { id: 5, name: 'Logo 6', src: '/lp-logo6.png' },
        { id: 6, name: 'Logo 7', src: '/lp-logo7.png' },                
        { id: 10, name: 'Logo 11', src: '/lp-logo11.png' },
        { id: 11, name: 'Logo 12', src: '/lp-logo12.png' },
        { id: 12, name: 'Logo 13', src: '/lp-logo13.svg' },
        { id: 13, name: 'Logo 14', src: '/lp-logo14.png' },
        { id: 14, name: 'Logo 15', src: '/lp-logo15.png' },
    ];

    const extendedLogos = [...logos, ...logos];

    // Animation Loop
    useEffect(() => {
        const scroll = () => {
            if (scrollContainerRef.current && !isPaused && !isDragging) {
                // Update precise float position
                scrollPos.current += speed;
                
                // Apply to actual DOM element
                scrollContainerRef.current.scrollLeft = scrollPos.current;
    
                // Infinite Reset Logic
                const maxScroll = scrollContainerRef.current.scrollWidth / 2;
                if (scrollPos.current >= maxScroll) {
                    scrollPos.current = 0;
                    scrollContainerRef.current.scrollLeft = 0;
                }
            }
            animationRef.current = requestAnimationFrame(scroll);
        };
    
        animationRef.current = requestAnimationFrame(scroll);
        return () => cancelAnimationFrame(animationRef.current);
    }, [isPaused, isDragging]);
    

    // --- MOUSE EVENTS ---
    const handleMouseDown = (e) => {
        setIsDragging(true);
        setStartX(e.pageX - scrollContainerRef.current.offsetLeft);
        setScrollLeft(scrollContainerRef.current.scrollLeft);
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - scrollContainerRef.current.offsetLeft;
        const walk = (x - startX) * 2;
        scrollContainerRef.current.scrollLeft = scrollLeft - walk;
        
        // SYNC HERE: Update our tracker to match the user's manual drag
        scrollPos.current = scrollContainerRef.current.scrollLeft;
    };

    const handleStopDrag = () => {
        setIsDragging(false);
        setIsPaused(false);
    };

    // --- TOUCH EVENTS (Mobile) ---
    const handleTouchStart = (e) => {
        // Stop auto-scroll immediately on touch
        setIsDragging(true);
        setIsPaused(true); 
        setStartX(e.touches[0].pageX - scrollContainerRef.current.offsetLeft);
        setScrollLeft(scrollContainerRef.current.scrollLeft);
    };

    const handleTouchMove = (e) => {
        if (!isDragging) return;
        const x = e.touches[0].pageX - scrollContainerRef.current.offsetLeft;
        const walk = (x - startX) * 1.5;
        scrollContainerRef.current.scrollLeft = scrollLeft - walk;
        
        // SYNC HERE
        scrollPos.current = scrollContainerRef.current.scrollLeft;
    };

    const handleTouchEnd = () => {
        setIsDragging(false);
        // We do NOT set isPaused(false) immediately if we want them to read it, 
        // but typically auto-scroll resumes when finger lifts:
        setIsPaused(false);
    };


    return (
        <div 
            className={isMobile?"lph-carousel-container-mobile":"lph-carousel-container"}
            // Mouse Events
            onMouseDown={handleMouseDown}
            onMouseLeave={handleStopDrag}
            onMouseUp={handleStopDrag}
            onMouseMove={handleMouseMove}
            
            // Touch Events
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
        >
            {/* <LPChip text="why worky" /> */}
            <LPChipAlt text="modern agencies run on worky" />
            <div className="lph-carousel-heading" style={{ marginBottom: isMobile ? '100px' : '40px' }}>Trusted by thousands of businesses and agencies worldwide</div>            


            <div className="lph-carousel-track" ref={scrollContainerRef}>
                {extendedLogos.map((logo, index) => (
                    <div key={`${logo.id}-${index}`} className={isMobile?"lph-logo-card-mobile":"lph-logo-card"}>
                        <img 
                            src={logo.src} 
                            alt={logo.name} 
                            className="lph-logo-img" 
                        />
                    </div>
                ))}
            </div>
        </div>
    );

}


const LPMission = ({ isMobile }: { isMobile: boolean }) => {}






const LPProduct = ({ isMobile }: { isMobile: boolean }) => {

    return(
        <div className={isMobile ? 'lp-products-holder-mobile' : 'lp-products-holder'}>

            <div className={isMobile ? 'lp-product-container-mobile lp-product-container-mobile-reverse' : 'lp-product-container'} style={{ height: 'auto', minHeight: isMobile ? undefined : '600px' }}>

                <div className={isMobile ? 'lp-product-container-inner-text-container-mobile' : 'lp-product-container-inner-text-container'}>
                    
                    <div className='lp-product-container-inner-icon-text-container'><div className={isMobile ? 'lp-product-container-inner-icon-mobile lp-product-container-inner-icon-cog' : 'lp-product-container-inner-icon lp-product-container-inner-icon-cog'} style={{background:'linear-gradient(135deg, #0ea5e9 0%, #22c55e 100%)'}}><Cog size={isMobile ? 18 : 22} /></div><LPChip direction="left" text="operations" /></div>
                    <div className={isMobile ? 'lp-product-container-inner-title-mobile' : 'lp-product-container-inner-title'}>One Platform. Smarter Operations.</div>                    
                    <div className={isMobile ? 'lp-product-container-inner-text-mobile' : 'lp-product-container-inner-text'}>
                        <b>Run your entire agency on one platform.</b>
                        <br />
                        <b>Automate from shift to invoicing with confidence.</b> 
                        <br />
                        Worky is the industry leading employment agency software platform, trusted by the fastest-growing agencies worldwide.
                        <br />
                        <br />
                        Worky replaces WhenIWork, QuickBooks, and ADP with a single system built specifically for agencies. Automate operations and scale faster.
                    </div>
                    <button onClick={(): void => { openWorkyCalendlyDemoInNewTab('lp_product_operations_get_demo'); }} className={isMobile ? 'lp-product-container-inner-button-mobile' : 'lp-product-container-inner-button'}>Get Demo {isMobile? null : <ChevronRight size={15} />}</button>
                </div>

                <div className={isMobile ? 'lp-product-container-inner-image-container-mobile' : 'lp-product-container-inner-image-container'} style={isMobile?{height:'auto'}:{}}>
                    <div className={isMobile ? 'lp-product-container-inner-image-mobile' : 'lp-product-container-inner-image'}>
                        {/* Previous animation: uncomment this and restore its import to revert. */}
                        {/* <WorkyOpsDemo /> */}
                        <WorkyCareOperationsDemo />
                        {/* <WorkyOpsDemoTwo /> */}
                    </div>
                </div>

            </div>
            



            <div className={isMobile ? 'lp-product-container-mobile lp-product-container-mobile-reverse' : 'lp-product-container'}>

                <div className={isMobile ? 'lp-product-container-inner-image-container-mobile' : 'lp-product-container-inner-image-container'}>
                    <div className={isMobile ? 'lp-product-container-inner-image-mobile' : 'lp-product-container-inner-image'}><WorkySalesDemo /></div>
                </div>

                <div className={isMobile ? 'lp-product-container-inner-text-container-mobile' : 'lp-product-container-inner-text-container lp-product-container-inner-text-container-right'}>
                    
                    <div className='lp-product-container-inner-icon-text-container'><LPChip direction="right" text="sales" /><div className={isMobile ? 'lp-product-container-inner-icon-mobile lp-product-container-inner-icon-cog' : 'lp-product-container-inner-icon lp-product-container-inner-icon-cog'} style={{background:'linear-gradient(135deg, #f59e0b 0%, #ef4444 100%)'}}><Rocket size={isMobile ? 18 : 22} /></div></div>
                    <div className={isMobile ? 'lp-product-container-inner-title-mobile' : 'lp-product-container-inner-title'}>Close More Deals with AI Sales Intelligence</div>
                    <div className={isMobile ? 'lp-product-container-inner-text-mobile' : 'lp-product-container-inner-text'}>
                    Stop guessing and start closing. 
                    <br/>
                    <b>Worky provides agencies with high-intent verified leads who are actively looking to work with an agency. </b>
                    <br/>
                    <br/>
                    We find your ideal prospects and equip teams with actionable insights to crush quotas and accelerate growth.

                    </div>
                    <button onClick={(): void => { openWorkyCalendlyDemoInNewTab('lp_product_sales_get_demo'); }} className={isMobile ? 'lp-product-container-inner-button-mobile' : 'lp-product-container-inner-button'}> {isMobile? null : <ChevronRight style={{transform: 'rotate(180deg)'}} size={15} />}Get Demo</button>
                </div>

            </div>

            
            

            <div className={isMobile ? 'lp-product-container-mobile lp-product-container-mobile-reverse' : 'lp-product-container'}>

                <div className={isMobile ? 'lp-product-container-inner-text-container-mobile' : 'lp-product-container-inner-text-container'}>
                    
                    <div className='lp-product-container-inner-icon-text-container'><div className={isMobile ? 'lp-product-container-inner-icon-mobile lp-product-container-inner-icon-cog' : 'lp-product-container-inner-icon lp-product-container-inner-icon-cog'} style={{background:'linear-gradient(135deg, #6366f1 0%, #a855f7 100%)'}}><Store size={isMobile ? 18 : 22} /></div><LPChip direction="left" text="marketplace" /></div>
                    <div className={isMobile ? 'lp-product-container-inner-title-mobile' : 'lp-product-container-inner-title'}>Find the Right People for Your Care Team</div>
                    <div className={isMobile ? 'lp-product-container-inner-text-mobile' : 'lp-product-container-inner-text'}>
                        Connect with home-care and healthcare agencies to find support for your staffing needs.
                        <br/>
                        <br/>
                        From personal support workers to nursing staff, Worky helps match your request with care professionals based on experience, availability and location. Your team reviews the candidates and makes the final decision.
                    </div>
                    <button onClick={(): void => { openWorkyCalendlyDemoInNewTab('lp_product_marketplace_get_demo'); }} className={isMobile ? 'lp-product-container-inner-button-mobile' : 'lp-product-container-inner-button'}>Get Demo {isMobile? null : <ChevronRight size={15} />}</button>
                </div>

                <div className={isMobile ? 'lp-product-container-inner-image-container-mobile' : 'lp-product-container-inner-image-container'}>
                    <div className={isMobile ? 'lp-product-container-inner-image-mobile' : 'lp-product-container-inner-image'}>
                        <WorkyMarketplaceDemo />
                    </div>
                </div>

            </div>


            
        </div>
    )
}







const LPIndustries = ({ isMobile }: { isMobile: boolean }) => {
    const [selectedIndustry, setSelectedIndustry] = useState<string>('Healthcare');

    const industries = ['Healthcare', 'Recruiting', 'Staffing', 'Security', '+'];


    return(

        <div className={isMobile ? 'lp-industries-container-mobile' : 'lp-industries-container'}>
                <LPChip text="trusted by modern agencies" />
                <div className={isMobile ? "lph-carousel-heading-mobile" : "lph-carousel-heading"} style={{marginBottom:'20px'}}>Automate from shift to invoicing with confidence.</div>
                <div className={isMobile ? "lp-product-container-inner-text-mobile" : "lp-product-container-inner-text"} style={{textAlign:'center'}}>Learn how Worky has powered over $250M in payroll, enabling 1,500+ agency owners to grow their business.</div>
                <div className={isMobile ? 'lp-industries-container-inner-mobile' : 'lp-industries-container-inner'}>

                {/* <div className={isMobile ? 'lp-industries-selector-container-mobile' : 'lp-industries-selector-container'}>
                    {industries.map((industry, index) => (
                        <button 
                            key={industry}
                            className={`${isMobile ? 'lp-industries-selector-button-mobile' : 'lp-industries-selector-button'} ${selectedIndustry === industry ? 'lp-industries-selector-button-active' : ''} ${index === industries.length - 1 ? 'lp-industries-selector-button-last' : ''}`}
                            onClick={() => setSelectedIndustry(industry)}
                        >
                            {index === industries.length - 1 ? <Plus size={isMobile ? 15 : 17} /> : industry}
                        </button>
                    ))}
                </div> */}
<br/>
<br/>
<br/>
<br/>
                <div className={isMobile ? 'lp-industries-content-container-mobile' : 'lp-industries-content-container'}>
                    {selectedIndustry === 'Healthcare' ? <HealthcareBentoGrid /> : null}
                    {selectedIndustry === 'Recruiting' ? <RecruitingBentoGrid /> : null}
                    {selectedIndustry === 'Staffing' ? <StaffingBentoGrid /> : null}
                    {selectedIndustry === 'Security' ? <SecurityBentoGrid /> : null}
                    {selectedIndustry === '+' ? <OtherBentoGrid /> : null}
                </div>
            </div>
        </div>

    )
}



interface FooterFormData {
    readonly contactName: string;
    readonly contactCompanyName: string;
    readonly contactChannelValue: string;
    readonly contactPhoneNumber: string;
    readonly preferredCallDate: string;
    readonly preferredCallTime: string;
    readonly howCanWeHelp: string;
    readonly activeEmployeesRange: string;
}

const EMPTY_FOOTER_FORM_DATA: FooterFormData = {
    contactName: '',
    contactCompanyName: '',
    contactChannelValue: '',
    contactPhoneNumber: '',
    preferredCallDate: '',
    preferredCallTime: '',
    howCanWeHelp: '',
    activeEmployeesRange: '',
};

const LPFooter = ({ isMobile }: { isMobile: boolean }) => {
    const { enqueueSnackbar } = useSnackbar();
    const footerLeadFormInteractionStartedMarketingRef = useRef<boolean>(false);
    const [footerFormData, setFooterFormData] = useState<FooterFormData>(EMPTY_FOOTER_FORM_DATA);
    const [isFooterSubmitting, setIsFooterSubmitting] = useState<boolean>(false);
    const [footerCaptchaToken, setFooterCaptchaToken] = useState<string | null>(null);
    const [footerTurnstileResetSignal, setFooterTurnstileResetSignal] = useState<number>(0);

    const markFooterLeadFormInteractionStarted = (nextState: FooterFormData): void => {
        const hasMeaningfulTyping: boolean =
            isValidString(nextState.contactName.trim()) ||
            isValidString(nextState.contactCompanyName.trim()) ||
            isValidString(nextState.contactChannelValue.trim()) ||
            isValidString(nextState.contactPhoneNumber.trim()) ||
            isValidString(nextState.preferredCallDate.trim()) ||
            isValidString(nextState.preferredCallTime.trim()) ||
            isValidString(nextState.howCanWeHelp.trim()) ||
            isValidString(nextState.activeEmployeesRange);
        if (
            !footerLeadFormInteractionStartedMarketingRef.current &&
            hasMeaningfulTyping
        ) {
            footerLeadFormInteractionStartedMarketingRef.current = true;
            pushWorkyMarketingAnalyticsEvent({
                event: TAG_DICTIONARY.EVENTS.FORM_START,
                form_id: TAG_DICTIONARY.ENTITY_IDS.FORM_LANDING_FOOTER_LEAD,
                form_name: TAG_DICTIONARY.ENTITY_IDS.FORM_LANDING_FOOTER_LEAD,
            });
        }
    };

    const handleFooterFormChange = (fieldName: string, fieldValue: string): void => {
        setFooterFormData((prev: FooterFormData): FooterFormData => {
            const nextState: FooterFormData = {
                ...prev,
                [fieldName]: fieldValue,
            };
            markFooterLeadFormInteractionStarted(nextState);
            return nextState;
        });
    };

    const handleFooterFormSubmit = async (formData: FooterFormData): Promise<void> => {
        if (!isValidString(formData.contactName)) {
            enqueueSnackbar('Please enter your full name', { variant: 'error' });
            return;
        }
        if (!isValidString(formData.contactCompanyName)) {
            enqueueSnackbar('Please enter your company name', { variant: 'error' });
            return;
        }
        if (isBlockedHotIntakeEmailDomain(formData.contactChannelValue)) {
            enqueueSnackbar(HOT_INTAKE_BLOCKED_EMAIL_SNACKBAR, { variant: 'error' });
            return;
        }
        if (!isValidHotIntakeEmail(formData.contactChannelValue)) {
            enqueueSnackbar('Please enter a valid email', { variant: 'error' });
            return;
        }
        if (!isValidHotIntakePhone(formData.contactPhoneNumber)) {
            enqueueSnackbar('Please enter a valid phone number', { variant: 'error' });
            return;
        }
        if (!isValidOptionalHotIntakePreferredCallSlot(formData.preferredCallDate, formData.preferredCallTime)) {
            enqueueSnackbar('Please enter a valid preferred call date or time', { variant: 'error' });
            return;
        }
        if (!isValidString(footerCaptchaToken)) {
            enqueueSnackbar('Please complete the captcha verification', { variant: 'error' });
            return;
        }

        setIsFooterSubmitting(true);

        const payload: SalesTrackerHotIntakeReqDTO = {
            workySessionId: RetrieveFromLocalCache(LOCAL_STORAGE_KEYS.WORKY_SESSION_ID),
            contactName: formData.contactName.trim(),
            contactCompanyName: formData.contactCompanyName.trim(),
            contactChannelValue: formData.contactChannelValue.trim(),
            captchaToken: footerCaptchaToken,
            contactPhoneNumber: formData.contactPhoneNumber.trim(),
            ...(isValidString(formData.preferredCallDate)
                ? { preferredCallDate: formData.preferredCallDate.trim() }
                : {}),
            ...(isValidString(formData.preferredCallTime)
                ? { preferredCallTime: normalizeHotIntakePreferredCallTime(formData.preferredCallTime) }
                : {}),
            ...(isValidString(formData.howCanWeHelp) ? { howCanWeHelp: formData.howCanWeHelp.trim() } : {}),
            ...(isValidString(formData.activeEmployeesRange)
                ? { activeEmployeesRange: formData.activeEmployeesRange }
                : {}),
            primaryServiceAreas: null,
            operatingTenure: null,
        };

        try {
            const response: SalesTrackerHotIntakeReqDTO | null = await SalesTrackerHotIntakeAPICall(payload);
            if (response) {
                pushWorkyMarketingAnalyticsEvent({
                    event: TAG_DICTIONARY.EVENTS.FORM_SUBMIT,
                    form_id: TAG_DICTIONARY.ENTITY_IDS.FORM_LANDING_FOOTER_LEAD,
                    form_name: TAG_DICTIONARY.ENTITY_IDS.FORM_LANDING_FOOTER_LEAD,
                });
                IncrementPitchPopUpCount();
                setFooterFormData(EMPTY_FOOTER_FORM_DATA);
                setFooterCaptchaToken(null);
                setFooterTurnstileResetSignal((prev: number): number => prev + 1);
                window.location.assign(WORKY_WEB_APP_PATHS.leadSuccess);
                return;
            } else {
                enqueueSnackbar('Something went wrong, please try again', { variant: 'error' });
                setFooterCaptchaToken(null);
                setFooterTurnstileResetSignal((prev: number): number => prev + 1);
            }
        } catch (error) {
            enqueueSnackbar('Something went wrong, please try again', { variant: 'error' });
            setFooterCaptchaToken(null);
            setFooterTurnstileResetSignal((prev: number): number => prev + 1);
        }

        setIsFooterSubmitting(false);
    };

    return (
        <div id="lp-footer" className='lp-footer'>

            
            <div className={isMobile?'lp-footer-cta-container-mobile':'lp-footer-cta-container'}>
                <div className={isMobile?'lp-footer-cta-inner-mobile':'lp-footer-cta-inner'}>
                    
                    <LPChip text="get started" />
                    <div className={isMobile ? 'lp-product-container-inner-title-mobile' : 'lp-product-container-inner-title'} style={{color:'', maxWidth:'calc(100% - 40px)', textAlign:'center'}}>Sell more. Run leaner. <br/> All with Worky.</div>
                    <div className={isMobile ? 'lp-product-container-inner-text-mobile' : 'lp-product-container-inner-text'} style={{color:'', textAlign:'center', maxWidth:'600px', marginTop:'12px', marginBottom:'20px', lineHeight:'1.5'}}>Worky is the leading software provider in the agency software space for over 5 years.
                    Supporting the success of the fastest-growing agencies.
                    </div>
                    <div className='lp-footer-cta-incentive'>
                        {HOT_INTAKE_NEW_AGENCY_INCENTIVE_COPY}
                    </div>
                    
                    <form className={isMobile?'lp-footer-cta-input-container-mobile':'lp-footer-cta-input-container'} onSubmit={(e: React.FormEvent<HTMLFormElement>) => { e.preventDefault(); handleFooterFormSubmit(footerFormData); }}>
                        <input
                            className='lp-footer-cta-input'
                            placeholder='Full Name'
                            value={footerFormData.contactName}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleFooterFormChange('contactName', e.target.value)}
                        />
                        <input
                            className='lp-footer-cta-input'
                            placeholder='Company name'
                            value={footerFormData.contactCompanyName}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleFooterFormChange('contactCompanyName', e.target.value)}
                        />
                        <input
                            className='lp-footer-cta-input'
                            type='email'
                            placeholder='Email'
                            value={footerFormData.contactChannelValue}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleFooterFormChange('contactChannelValue', e.target.value)}
                        />
                        <input
                            className='lp-footer-cta-input'
                            placeholder='Phone number'
                            type='tel'
                            value={footerFormData.contactPhoneNumber}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleFooterFormChange('contactPhoneNumber', e.target.value)}
                        />
                        {/* Temporarily hidden: preferred call date/time
                        <div className='lp-footer-cta-preferred-call'>
                            <label className='lp-hot-intake-org-label' htmlFor='lp-footer-preferred-call-date'>
                                When is a preferred time for us to reach out to you for a call (optional)
                            </label>
                            <input
                                id='lp-footer-preferred-call-date'
                                className='lp-footer-cta-input'
                                type='date'
                                placeholder='yyyy-mm-dd'
                                value={footerFormData.preferredCallDate}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleFooterFormChange('preferredCallDate', e.target.value)}
                                aria-label='Preferred call date yyyy-mm-dd'
                            />
                            <input
                                id='lp-footer-preferred-call-time'
                                className='lp-footer-cta-input'
                                type='text'
                                placeholder='e.g. 11:00 AM'
                                value={footerFormData.preferredCallTime}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleFooterFormChange('preferredCallTime', e.target.value)}
                                aria-label='Preferred call time'
                                autoComplete='off'
                                inputMode='text'
                            />
                        </div>
                        */}
                        <textarea
                            className='lp-footer-cta-input lp-footer-cta-textarea'
                            placeholder='How can we help? (optional)'
                            rows={2}
                            value={footerFormData.howCanWeHelp}
                            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => handleFooterFormChange('howCanWeHelp', e.target.value)}
                        />
                        <select
                            className='lp-footer-cta-input lp-hot-intake-select'
                            value={footerFormData.activeEmployeesRange}
                            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => handleFooterFormChange('activeEmployeesRange', e.target.value)}
                            aria-label='How many employees do you have (optional)'
                        >
                            <option value=''>How many employees do you have (optional)</option>
                            {HOT_INTAKE_ACTIVE_EMPLOYEES_OPTIONS.map((option: HotIntakeSelectOption) => (
                                <option key={option.value} value={option.value}>{option.label}</option>
                            ))}
                        </select>
                        <TurnstileWidget
                            className='lp-hot-intake-turnstile'
                            onTokenChange={setFooterCaptchaToken}
                            resetSignal={footerTurnstileResetSignal}
                        />
                        <button type='submit' className='lp-footer-cta-button lp-cta-button' disabled={isFooterSubmitting}>
                            {isFooterSubmitting ? 'Sending...' : 'Submit'} {!isFooterSubmitting && <Send size={14} />}
                        </button>
                    </form>

                </div>
            </div>

            <div className='lp-footer-content'>
                <div className='lp-footer-content-1'>
                    <div className='lp-footer-main'>
                        <div className='lp-footer-left'>
                            <div className='lp-footer-logo'>
                                <span className='lp-footer-logo-text'>worky</span>
                            </div>
                            <p className='lp-footer-description'>
                            Worky is the all-in-one platform built for modern agencies. Close more deals with the Worky Sales Suite, run lean operations with the Worky Operations Suite, and tap into the world's largest agency network with the Worky Marketplace — all from a single platform.
                            </p>
                            <div className='lp-footer-social'>
                                {/* <a href="https://twitter.com/worky_pro"  rel="noreferrer" className='lp-footer-social-link'><Twitter size={20} /></a> */}
                                <a href="https://www.instagram.com/worky.pro/" rel="noreferrer" className='lp-footer-social-link'><Instagram size={20} /></a>
                                <a href="https://www.linkedin.com/company/worky-pro" rel="noreferrer" className='lp-footer-social-link'><Linkedin size={20} /></a>
                            </div>
                        </div>


                        {/* Always-rendered <a href> links so crawlers can discover marketing URLs without JS expand clicks. */}
                        <div className={isMobile ? 'lp-footer-right-mobile' : 'lp-footer-right'}>
                            <div className='lp-footer-column'>
                                <h3 className='lp-footer-column-title'>Products</h3>
                                <ul className='lp-footer-column-links'>
                                    <li><a href={WORKY_WEB_APP_PATHS.landingPageSales}>Sales Suite</a></li>
                                    <li><a href={WORKY_WEB_APP_PATHS.landingPageOperations}>Operations Suite</a></li>
                                    <li><a href={WORKY_WEB_APP_PATHS.landingPageMarketplace}>Marketplace</a></li>
                                    <li><a href={WORKY_WEB_APP_PATHS.landingPageProducts}>All Products</a></li>
                                    <li><a href={WORKY_WEB_APP_PATHS.landingPageHomecare}>Home Care</a></li>
                                </ul>
                            </div>
                            <div className='lp-footer-column'>
                                <h3 className='lp-footer-column-title'>Resources</h3>
                                <ul className='lp-footer-column-links'>
                                    <li><a href={WORKY_WEB_APP_PATHS.landingPageResources}>Resources</a></li>
                                    <li><a href={WORKY_WEB_APP_PATHS.landingPageBlog}>Blog</a></li>
                                    <li><a href={WORKY_WEB_APP_PATHS.landingPageCareers}>Careers</a></li>
                                    <li><a href={WORKY_WEB_APP_PATHS.landingPageCompare}>Compare</a></li>
                                </ul>
                            </div>
                            <div className='lp-footer-column'>
                                <h3 className='lp-footer-column-title'>Contact</h3>
                                <ul className='lp-footer-column-links'>
                                    <li><a href="mailto:info@worky.pro">info@worky.pro</a></li>
                                    <li><a href="tel:+16474949090">(647) 494-9090</a></li>
                                    <li><a href={WORKY_WEB_APP_PATHS.contactSales}>Contact Sales</a></li>
                                    <li className='lp-footer-column-links-btn'>
                                        <a
                                            href="https://calendly.com/worky-pro/30min"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                openWorkyCalendlyDemoInNewTab('lp_footer_contact_get_demo');
                                            }}
                                        >
                                            Get Demo
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>





                    </div>
                    <div className='lp-footer-divider'></div>
                    <div className='lp-footer-bottom'>
                        <span className='lp-footer-copyright'>© 2026 Worky. All rights reserved.</span>
                        <div className='lp-footer-legal'>
                            <a href="/privacy">Privacy Policy</a>
                            {/* <a href="/landing-page-terms">Terms of Service</a> */}
                            <a href="/delete-my-data">Delete My Data</a>
                        </div>
                    </div>
                </div>
                                
                <div className='lp-footer-content-2'>
                    worky
                </div>
            </div>

        </div>
    )
}









  
// moved to `LandingPageSubComponents.tsx`
  







const LandingPage = () => {
    const isMobile = useIsMobile();
    useLandingPageSeo(homeSeo);

    // useEffect(() => {
    //     ListenForPageCloseAndExecute();
    //     try {
    //         void MakeRemoteTrackingEventCall({ eventName: 'LANDING_PAGE_VIEW' });
    //     } catch (e) {
    //         console.log('error on LANDING_PAGE_VIEW', e);
    //     }
    // }, []);

    // Handle hash-based navigation (e.g., /landing-page#pricing-section)
    useEffect(() => {
        handleHashScroll({ offset: isMobile ? 70 : 80 });
    }, [isMobile]);

    return (
        <div>
            <LandingNavigation/>
            {/* <WavyBackground/> */}
            
            
            <LPHero isMobile={isMobile}/>
            
            

            
            {/* <HeroSection/> */}
            {/* <LPProduct isMobile={isMobile}/> */}
            {/* <LPIndustries isMobile={isMobile}/>

            <LPTestimonials isMobile={isMobile}/>

            <LPPricing isMobile={isMobile}/> */}

            {/* <LPFooter isMobile={isMobile}/> */}


        </div>
    );
};

export {LandingPage, LPFooter, LPChip, AnimatedFlameSpan, AnimatedCogSpan, AnimatedStoreSpan};